import { isPlatformBrowser } from '@angular/common';
import { type EnvironmentProviders, inject, PLATFORM_ID, provideAppInitializer } from '@angular/core';

import { DemoCodeAssist } from './demo-code-assist';

export const provideDemoCodeAssist = (): EnvironmentProviders =>
  provideAppInitializer(() => {
    if (isPlatformBrowser(inject(PLATFORM_ID))) inject(DemoCodeAssist).start();
  });
